import { useContext } from 'react';
import { ApprovalsContext } from '../Approvals.provider';

export default function useOpenConfirmationDialog() {
  const { orderToApproveOrDecline, setOrderToApproveOrDecline } =
    useContext(ApprovalsContext);

  const openConfirmationDialog = order => {
    setOrderToApproveOrDecline(order);
  };

  const closeConfirmationDialog = () => {
    setOrderToApproveOrDecline(null);
  };

  const open = !!orderToApproveOrDecline;

  return { open, openConfirmationDialog, closeConfirmationDialog };
}
